import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom";
import { FEATURE_FLAGS } from "../../config/featureFlags";

function WebHeader() {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
        return localStorage.getItem('currentUser') !== null;
    });

    useEffect(() => {
        const checkAuth = () => {
            setIsLoggedIn(localStorage.getItem('currentUser') !== null);
        };
        window.addEventListener('auth-change', checkAuth);
        window.addEventListener('storage', checkAuth);
        return () => {
            window.removeEventListener('auth-change', checkAuth);
            window.removeEventListener('storage', checkAuth);
        };
    }, []);

    return (
        <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
            <div className="container">
                <a className="navbar-brand" href="/">
                    <img 
                        src={`${process.env.PUBLIC_URL}/image/aapligaadi-dark.png`} 
                        alt="Aapli Gaadi Logo" 
                        style={{ height: '55px', maxHeight: '50px', maxWidth: '160px', width: 'auto', objectFit: 'contain' }}
                    />
                </a>
                <button 
                    className="navbar-toggler" 
                    type="button" 
                    onClick={() => setIsOpen(!isOpen)}
                    aria-controls="ftco-nav" 
                    aria-expanded={isOpen} 
                    aria-label="Toggle navigation"
                >
                    <span className="oi oi-menu"></span> Menu
                </button>

                <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="ftco-nav">
                    <ul className="navbar-nav ml-auto" onClick={() => setIsOpen(false)}>
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about">About Us</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/services">Services</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/terms-and-conditions">Terms & Conditions</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/payment-options">Payment Options</Link>
                        </li>
                        {FEATURE_FLAGS.ENABLE_EXTRA_FEATURES && (
                            <li className="nav-item">
                                <Link className="nav-link" to="/blogs">Blogs</Link>
                            </li>
                        )}
                        {FEATURE_FLAGS.ENABLE_EXTRA_FEATURES && (
                            isLoggedIn ? (
                                <li className="nav-item">
                                    <Link className="nav-link text-primary font-weight-bold" to="/my-account">My Account</Link>
                                </li>
                            ) : (
                                <li className="nav-item">
                                    <Link className="nav-link text-primary font-weight-bold" to="/my-account">Login / Register</Link>
                                </li>
                            )
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default WebHeader;